var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "box",
    { staticClass: "_flexcol", attrs: { content: "" } },
    [
      _c(
        "div",
        { staticClass: "_flex _ai-c" },
        [
          _c("skeleton-image", { staticClass: "_ma-3", attrs: { size: 42 } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_flexcol _w-100 _gap-2" },
            [
              _c("skeleton-line", {
                attrs: { height: 22, "width-percent": 30 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                attrs: { height: 20, "width-percent": 20 },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("base-divider", { staticClass: "_my-0" }),
      _vm._v(" "),
      _c("div", { class: _vm.contentClasses }, [
        _c(
          "div",
          { class: { "_w-100": _vm.isMobile } },
          [
            _c("skeleton-image", {
              staticClass: "_mx-3",
              attrs: { size: _vm.mainImageSize },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "_w-100" }, [
          _c(
            "div",
            { staticClass: "_flexcol _gap-2 _mx-3" },
            [
              _c("skeleton-line", {
                attrs: { height: 22, "width-percent": 20 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                attrs: { height: 28, "width-percent": 30 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                attrs: { height: 22, "width-percent": 100 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                attrs: { height: 22, "width-percent": 100 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                attrs: { height: 20, "width-percent": 15 },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("base-divider", { staticClass: "_my-0" }),
      _vm._v(" "),
      _c("skeleton-line", {
        staticClass: "_ma-3",
        attrs: { height: 20, "width-percent": 10 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }